import { useTranslation } from "react-i18next";
import Footer from "../components/Footer";
import Header from "../components/Header";
import Title from "../components/Title";
import { CONTACT_PATH } from "../Routes/paths";
import { useNavigate } from "react-router-dom";
import Contact from "../components/Contact";

interface WebAppDevProps {}

const WebAppDev = ({}: WebAppDevProps) => {
  const { i18n, t } = useTranslation();
  const navigate = useNavigate();
  return (
    <>
      <Header />

      <main
        className={`w-full ${
          i18n.language === "en" ? "font-Poppins" : "font-Almarai"
        }`}
      >
        {/* hero section  *****************************/}
        <Title
          title={t("Web Application Development")}
          subtitle={t("Services")}
          thirdTitle={t("Web Application Development")}
        />

        {/* next section  ******************************/}
        <section className="my-[20px] px-[20px] w-full flex flex-col items-center justify-center gap-8 lg:gap-0 lg:flex-row lg:items-center lg:justify-around ">
          <div>
            <img src="../images/WebApplicationDevelopment.png" alt="" />
          </div>
          <div>
            <p
              className={`max-w-[800px] lg:text-[14px] text-center ${
                i18n.language === "en" ? "lg:text-left" : "lg:text-right"
              }`}
            >
              {t(
                "What does web application development mean? Wikipedia says: “an application that is accessed via a web browser over a network such as the Internet or an intranet. Web applications are gaining popularity over desktop applications because they are easy to update, distribute and scale. They typically require nothing to be installed on the users’ computer and can be used by thousands of users simultaneously. We believe this is the future. First of all we suggest to decide on the limits of your budget and have some idea of what you want. Very important is to understand, that your web site is an investment, serves as your introduction of your company image."
              )}
            </p>
          </div>
        </section>

        {/*  Our core service is developing **************/}
        <section className="my-[100px] px-[20px] lg:px-[144px] 2xl:px-[180px] w-full flex flex-col gap-10">
          <p className="font-[700] text-[24px] lg:text-[28px] flex items-center justify-center">
            {t(
              "Our core service is developing for Business and Custom made applications"
            )}
          </p>
          {/* grid section  *****************/}
          <div className="w-full grid grid-cols-1 lg:grid-cols-2 gap-8">
            <div>
              <p className="font-[700] text-[20px]">
                {t("Social Network Applications")}
              </p>
              <p className="text-[14px] max-w-[536px]">
                {t(
                  "We design and develop feature-rich, scalable, and secure social networking platforms tailored to your unique requirements"
                )}
              </p>
            </div>

            <div>
              <p className="font-[700] text-[20px]">
                {t("Custom product catalogs")}
              </p>
              <p className="text-[14px] max-w-[536px]">
                {t(
                  "We create dynamic, user-friendly product catalogs tailored to your business needs, enhancing user experience and driving sales."
                )}
              </p>
            </div>

            <div>
              <p className="font-[700] text-[20px]">
                {t("Web application interfaces")}
              </p>
              <p className="text-[14px] max-w-[536px]">
                {t(
                  "We design intuitive, responsive interfaces that optimize user interaction and streamline workflows for your web applications."
                )}
              </p>
            </div>

            <div>
              <p className="font-[700] text-[20px]">
                {t("Reservation Systems")}
              </p>
              <p className="text-[14px] max-w-[536px]">
                {t(
                  "We develop custom solutions that simplify the reservation process, improve efficiency, and enhance customer satisfaction."
                )}
              </p>
            </div>

            <div>
              <p className="font-[700] text-[20px]">{t("Tickets System")}</p>
              <p className="text-[14px] max-w-[536px]">
                {t(
                  "We create efficient solutions to handle tickets, ensuring smooth communication and resolution processes for your business."
                )}
              </p>
            </div>

            <div>
              <p className="font-[700] text-[20px]">
                {t("Customer Relationship Management (CRM)")}
              </p>
              <p className="text-[14px] max-w-[536px]">
                {t(
                  "We develop powerful, scalable CRM systems that enhance customer satisfaction, streamline operations, and drive growth for your business."
                )}
              </p>
            </div>

            <div>
              <p className="font-[700] text-[20px]">
                {t("Intranets and extranets")}
              </p>
              <p className="text-[14px] max-w-[536px]">
                {t(
                  "We design secure, scalable platforms that facilitate efficient communication, document sharing, and workflow management."
                )}
              </p>
            </div>

            <div>
              <p className="font-[700] text-[20px]">{t("Web portals")}</p>
              <p className="text-[14px] max-w-[536px]">
                {t(
                  "We create intuitive, personalized portals that centralize content, applications, and services, enhancing user engagement and productivity."
                )}
              </p>
            </div>

            <div>
              <p className="font-[700] text-[20px]">
                {t("Advertising Banner Management")}
              </p>
              <p className="text-[14px] max-w-[536px]">
                {t(
                  "We develop sophisticated platforms to manage and optimize advertising campaigns, ensuring targeted delivery and maximizing ROI for your business."
                )}
              </p>
            </div>

            <div>
              <p className="font-[700] text-[20px]">{t("Payment gateways")}</p>
              <p className="text-[14px] max-w-[536px]">
                {t(
                  "We integrate reliable payment processing systems that ensure seamless transactions and enhanced customer trust and satisfaction."
                )}
              </p>
            </div>
          </div>
        </section>

        {/* Connect With Us: Your Voice Heard **************/}
        <Contact />
      </main>

      <Footer />
    </>
  );
};

export default WebAppDev;
